export default __webpack_public_path__ + "static/media/90s_bg_desktop@2x.6d1205f7.jpg";